import Layout2 from '@/layout/Layout2'
import { RouterTabRoutes } from 'vue-router-tab'

export default [{
  path: '/System',
  component: Layout2,
  children: [
    ...RouterTabRoutes,
    {
      path: 'Base/Menu',
      meta: { title: '菜单管理' },
      component: () => import('@/components/System/Base/Menu')
    },
    {
      path: 'Base/Power',
      meta: { title: '权限管理' },
      component: () => import('@/components/System/Base/Power')
    },
    {
      path: 'Base/MenuPower',
      meta: { title: '菜单权限' },
      component: () => import('@/components/System/Base/MenuPower')
    },
    {
      path: 'Base/Account',
      meta: { title: '账户管理' },
      component: () => import('@/components/System/Base/Account')
    },
    {
      path: 'Base/Role',
      meta: { title: '角色管理' },
      component: () => import('@/components/System/Base/Role')
    },
    {
      path: 'Base/RoleFrame',
      meta: { title: '角色管理' },
      component: () => import('@/components/System/Base/RoleFrame')
    }]
}]
